import { Breadcrumb, Button, Col, Empty, Form, message, Row, Select, Table } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component, FormEvent } from 'react';
import { Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as xlsx from 'xlsx';

import { Panel } from '../../components/Panel';
import { FormatDate } from '../../components/table/Date';
import { EnrollmentGroup } from '../../types/enrollment';
import { GTeacher, USER_SOURCE_TO_NAME } from '../../types/teacher';

export const groupListQuery = gql`
  query getGroupListQuery($skuIds: [ID], $teacherIds: [ID], $name: String) {
    enrollmentGroups(skuIds: $skuIds, teacherIds: $teacherIds, name: $name) {
      id
      name
      createdAt
      sku {
        id
        name
        start
        end
      }
      userSource
      teacher {
        id
        name
      }
      enrollments {
        id
      }
    }
  }
`;

interface GroupListData {
  enrollmentGroups: EnrollmentGroup[];
}

interface State {
  pageSize: number;
  currentPage: number;
  selectedIndex: number;
  variables: {
    name?: string;
    teacherIds?: number[];
    skuIds?: number[];
  };
}
interface Props {
  form: WrappedFormUtils;
  skuIds?: string;
  teacherIds?: string;
}

type AllProps = RouteComponentProps<{}> & Props;
export class GroupListComponents extends Component<AllProps, State> {
  private teachers: GTeacher[] = [];
  private skus: { id: number; name: string }[] = [];
  constructor(props: AllProps) {
    super(props);
    this.state = {
      pageSize: 10,
      currentPage: 1,
      selectedIndex: 0,
      variables: {},
    };
    this.search = this.search.bind(this);
    this.onResetClick = this.onResetClick.bind(this);
  }
  getGroupListQueryVariables() {
    const { skuIds, teacherIds } = this.props;
    let teacherIdsArr: number[];
    let idsArr: number[];
    const variables: {
      teacherIds?: number[];
      skuIds?: number[];
    } = {};
    if (teacherIds) {
      teacherIdsArr = [Number(teacherIds)];
      variables.teacherIds = teacherIdsArr;
    }
    if (skuIds) {
      idsArr = [Number(skuIds)];
      variables.skuIds = idsArr;
    }
    this.setState({
      variables,
    });
  }
  componentWillMount() {
    this.getGroupListQueryVariables();
  }

  search(e: FormEvent) {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        message.error(err);
        return;
      }
      const selectedIndex = values.teachersId && Number(values.teachersId);
      const teacherIds = values.teachersId && [this.teachers[Number(values.teachersId)].id];
      const skuIds = values.skuIds ? [values.skuIds] : [];
      const groupName = values.groupName && values.groupName;
      let variables: {
        teacherIds?: number[];
        name?: string;
        skuIds?: number[];
      } = {};
      if (this.props.skuIds) {
        if (teacherIds && teacherIds.length && teacherIds[0] !== -1) {
          variables = { teacherIds, skuIds: this.state.variables.skuIds, name: groupName };
        } else {
          variables = { skuIds: this.state.variables.skuIds, name: groupName };
        }
      }

      if (this.props.teacherIds) {
        if (skuIds && skuIds.length && skuIds[0] !== -1) {
          variables = { skuIds, teacherIds: this.state.variables.teacherIds, name: groupName };
        } else {
          variables = { teacherIds: this.state.variables.teacherIds, name: groupName };
        }
      }
      this.setState({
        selectedIndex,
        variables,
      });
    });
  }

  onResetClick() {
    this.props.form.resetFields();
  }
  noRepeat(enrollmentGroups: EnrollmentGroup[]) {
    const teachers = new Map();
    for (const { teacher } of enrollmentGroups) {
      if (teacher) {
        teachers.set(teacher.id, teacher);
      }
    }
    const allteacher = { enrollmentGroups, id: -1, name: '所有' };
    teachers.set(allteacher.id, allteacher);
    return Array.from(teachers.values());
  }
  exportExcel = (enrollmentGroups: EnrollmentGroup[] | null) => {
    if (!enrollmentGroups) {
      return;
    }
    const group: object[] = [];
    for (const enrollmentGroup of enrollmentGroups) {
      if (!enrollmentGroup || !enrollmentGroup.sku) {
        continue;
      }
      if (!enrollmentGroup.teacher) {
        group.push({
          createdAt: enrollmentGroup.createdAt,
          groupName: enrollmentGroup.name,
          teacherName: 'null',
          groupUserCount: enrollmentGroup.enrollments.length,
          skuName: enrollmentGroup.sku.name,
          skuStart: enrollmentGroup.sku.start,
        });
      } else {
        group.push({
          createdAt: enrollmentGroup.createdAt,
          groupName: enrollmentGroup.name,
          teacherName: enrollmentGroup.teacher.name,
          groupUserCount: enrollmentGroup.enrollments.length,
          skuName: enrollmentGroup.sku.name,
          skuStart: enrollmentGroup.sku.start,
        });
      }
    }
    const workbook = xlsx.utils.book_new();
    const sheet1 = xlsx.utils.json_to_sheet(group);
    xlsx.utils.book_append_sheet(workbook, sheet1);
    xlsx.writeFile(workbook, 'out.xlsx');
  };
  skusNoRepeat(enrollmentGroups: EnrollmentGroup[]) {
    const skus: { id: number; name: string }[] = enrollmentGroups.map(enrollmentGroup => {
      return {
        id: enrollmentGroup.sku.id,
        name: enrollmentGroup.sku.name,
      };
    });
    const skusNoRepeat = new Map();
    for (const sku of skus) {
      if (sku) {
        skusNoRepeat.set(sku.id, sku);
      }
    }
    const allsku = { enrollmentGroups, id: -1, name: '所有' };
    skusNoRepeat.set(allsku.id, allsku);
    const skusNoRepeatSort = Array.from(skusNoRepeat.values()).sort((a, b) => {
      return a.id - b.id;
    });
    return skusNoRepeatSort;
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Query<GroupListData> query={groupListQuery} variables={this.state.variables}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const { enrollmentGroups = [] } = data || {};
          let enrollmentGroup: EnrollmentGroup | undefined;
          if (enrollmentGroups && enrollmentGroups.length > 0) {
            if (this.props.teacherIds) {
              enrollmentGroup = enrollmentGroups.find(
                item => Number(item.teacher.id) === Number(this.props.teacherIds),
              );
            }
            if (this.props.skuIds) {
              enrollmentGroup = enrollmentGroups.find(item => Number(item.sku.id) === Number(this.props.skuIds));
            }
          }
          if (enrollmentGroups && enrollmentGroups.length > 0 && this.teachers.length === 0) {
            this.teachers = this.noRepeat(enrollmentGroups).sort((a, b) => {
              return a.id - b.id;
            });
            this.skus = this.skusNoRepeat(enrollmentGroups);
          }

          return (
            <>
              <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
                <Breadcrumb.Item>
                  <Link to={`/Home`}>首页</Link>
                </Breadcrumb.Item>
                {this.props.skuIds && (
                  <>
                    <Breadcrumb.Item>
                      <Link to={`/group/skus/group`}>社群管理</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{enrollmentGroup && enrollmentGroup.sku.name}</Breadcrumb.Item>
                  </>
                )}
                {this.props.teacherIds && (
                  <>
                    <Breadcrumb.Item>
                      <Link to={`/teacher/list`}>班主任管理</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>{enrollmentGroup && enrollmentGroup.teacher.name}</Breadcrumb.Item>
                  </>
                )}
              </Breadcrumb>
              <Panel style={{ padding: 24 }}>
                <Form layout="inline" onSubmit={this.search}>
                  <Row gutter={24}>
                    {this.props.skuIds && (
                      <>
                        {this.teachers && this.teachers.length > 0 && (
                          <Col xs={24} md={24} lg={24} xl={10} xxl={6} style={{ marginTop: 8 }}>
                            <Form.Item label={`群管理员`}>
                              {getFieldDecorator('teachersId')(
                                <Select style={{ width: 270 }} placeholder="请选择群管理员">
                                  {this.teachers.map((option, index) => (
                                    <Select.Option value={index} key={String(option.id)}>
                                      {option.name}
                                    </Select.Option>
                                  ))}
                                </Select>,
                              )}
                            </Form.Item>
                          </Col>
                        )}
                      </>
                    )}

                    {this.props.teacherIds && (
                      <Col style={{ marginTop: 8 }} xs={24} md={24} lg={24} xl={10} xxl={6}>
                        <Form.Item label={`sku`}>
                          {getFieldDecorator('skuIds')(
                            <Select style={{ width: 280 }} allowClear showSearch placeholder="请选择sku">
                              {this.skus.map(sku => (
                                <Select.Option value={sku.id} key={String(sku.id)}>
                                  {sku.name}
                                </Select.Option>
                              ))}
                            </Select>,
                          )}
                        </Form.Item>
                      </Col>
                    )}
                    <Col style={{ marginTop: 8 }} xs={24} md={24} lg={24} xl={10} xxl={6}>
                      <Form.Item label={`社群`}>
                        {getFieldDecorator('groupName')(
                          <Select style={{ width: 280 }} allowClear showSearch placeholder="请选择社群">
                            {enrollmentGroups.map(enrollmentGroup => (
                              <Select.Option value={enrollmentGroup.name} key={enrollmentGroup.id}>
                                {enrollmentGroup.name}
                              </Select.Option>
                            ))}
                          </Select>,
                        )}
                      </Form.Item>
                    </Col>
                    <Col style={{ marginTop: 8, textAlign: 'right' }} xs={24} md={24} lg={24} xl={10} xxl={6}>
                      <Button style={{ marginRight: 8 }} type="primary" htmlType="submit" icon="search">
                        搜索
                      </Button>
                      <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                        重置
                      </Button>
                      <Button
                        type="primary"
                        icon="download"
                        onClick={() => {
                          this.exportExcel(enrollmentGroups);
                        }}
                      >
                        导出
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Panel>
              <Panel style={{ marginTop: 16 }}>
                <Table
                  dataSource={enrollmentGroups}
                  pagination={false}
                  loading={loading}
                  rowKey={record => `${record.id}`}
                >
                  <Table.Column
                    title="创建时间"
                    dataIndex="createdAt"
                    key="createdAt"
                    render={createdAt => <FormatDate mode="date" date={createdAt} />}
                  />
                  <Table.Column title="群名称" dataIndex="name" key="name" />
                  <Table.Column
                    title="学生来源"
                    dataIndex="userSource"
                    key="userSource"
                    render={userSource => USER_SOURCE_TO_NAME[userSource]}
                  />
                  <Table.Column title="群管理员" dataIndex="teacher.name" key="teacherName" />
                  <Table.Column title="群用户数" dataIndex="enrollments.length" key="enrollmentsLength" />
                  <Table.Column title="课程SKU" dataIndex="sku.name" key="skuName" />
                  <Table.Column<EnrollmentGroup>
                    title="开课时间"
                    dataIndex="sku.start"
                    key="skuStart"
                    render={skuStart => <FormatDate mode="date" date={skuStart} />}
                    defaultSortOrder="descend"
                    sorter={(a, b) => {
                      return moment(a.sku.start).valueOf() - moment(b.sku.start).valueOf();
                    }}
                  />
                  <Table.Column
                    title="操作"
                    key="action"
                    render={row => (
                      <Link to={`/group/sku/${row.sku.id}/group/${row.id}?teacherId=${this.props.teacherIds}`}>
                        详情
                      </Link>
                    )}
                  />
                </Table>
              </Panel>
            </>
          );
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/GroupListComponents.tsx